import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "qrPanel", "passwordPanel", "qrTab", "passwordTab", "qrImage", "status", "retry"
  ]
  static values = { createUrl: String }

  connect() {
    this.pollTimer = null
    this.loginSession = null
    this.createLoginSession()
  }

  disconnect() {
    this.stopPolling()
  }

  showQr() {
    this.qrPanelTarget.hidden = false
    this.passwordPanelTarget.hidden = true
    this.qrTabTarget.setAttribute("aria-selected", "true")
    this.passwordTabTarget.setAttribute("aria-selected", "false")
    if (!this.loginSession) this.createLoginSession()
  }

  showPassword() {
    this.qrPanelTarget.hidden = true
    this.passwordPanelTarget.hidden = false
    this.qrTabTarget.setAttribute("aria-selected", "false")
    this.passwordTabTarget.setAttribute("aria-selected", "true")
    this.stopPolling()
  }

  async retry() {
    await this.createLoginSession()
  }

  async createLoginSession() {
    this.stopPolling()
    this.loginSession = null
    this.qrImageTarget.hidden = true
    this.retryTarget.hidden = true
    this.setStatus("正在获取二维码...")

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: "{}"
      })
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || "二维码获取失败")

      this.loginSession = data
      this.qrImageTarget.src = data.qr_code_url
      this.qrImageTarget.hidden = false
      this.setStatus("使用微信扫码并关注服务号")
      this.startPolling(data.poll_interval_seconds * 1000)
    } catch (error) {
      this.setStatus(error.message)
      this.retryTarget.hidden = false
    }
  }

  startPolling(interval) {
    this.stopPolling()
    this.pollTimer = window.setInterval(() => this.poll(), interval)
  }

  stopPolling() {
    if (this.pollTimer) window.clearInterval(this.pollTimer)
    this.pollTimer = null
  }

  async poll() {
    if (!this.loginSession) return

    try {
      const response = await fetch(this.loginSession.poll_url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({ poll_token: this.loginSession.poll_token })
      })
      const data = await response.json()

      if (data.status === "authenticated") {
        this.stopPolling()
        this.setStatus("登录成功，正在进入...")
        window.location.assign(data.redirect_url)
      } else if (data.status === "scanned") {
        this.setStatus("已扫码，请在微信中确认登录")
      } else if (data.status === "rejected") {
        this.stopPolling()
        this.qrImageTarget.hidden = true
        this.setStatus("已取消登录")
        this.retryTarget.hidden = false
      } else if (data.status === "expired" || response.status === 410) {
        this.stopPolling()
        this.qrImageTarget.hidden = true
        this.setStatus("二维码已过期")
        this.retryTarget.hidden = false
      }
    } catch (_) {
      // A later poll can recover from a transient network failure.
    }
  }

  setStatus(message) {
    this.statusTarget.textContent = message
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
